(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["payment-icons"] && !Shopify.designMode) return;
  try {
    /* Trims the row to what actually fits. Liquid has already ordered the icons by
     importance and capped the count, so hiding from the end always drops the
     least important method first. Runs on resize because the drawer, the cart
     summary column and the footer all change width independently of the
     viewport. */
  if (!window.customElements.get('payment-icons')) {
    class PaymentIcons extends HTMLElement {
      connectedCallback() {
        this.icons = Array.from(this.children);
        this.fit = this.fit.bind(this);

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.fit);
          this.observer.observe(this);
        } else {
          window.addEventListener('resize', this.fit);
        }
        this.fit();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.fit);
      }

      fit() {
        if (!this.icons || this.icons.length === 0) return;

        /* Measure with everything shown, otherwise a row that was trimmed
           narrow can never grow back when space returns. */
        for (const icon of this.icons) icon.hidden = false;

        const available = this.clientWidth;
        if (available === 0) return; /* not laid out yet, e.g. a closed drawer */

        const styles = window.getComputedStyle(this);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;

        let used = 0;
        let shown = 0;

        for (const icon of this.icons) {
          const width = icon.getBoundingClientRect().width;
          const next = used + width + (shown > 0 ? gap : 0);
          if (next > available && shown > 0) break;
          used = next;
          shown += 1;
        }

        for (let i = shown; i < this.icons.length; i += 1) {
          this.icons[i].hidden = true;
        }
      }
    }

    window.customElements.define('payment-icons', PaymentIcons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /**
 * NF-CARD — click-to-switch swatch handler (Round 28)
 * One delegated listener on document handles all cards.
 * Click or Enter/Space on a .nf-card__swatch:
 *   1) prevents parent <a> navigation
 *   2) updates the card's image, price, compare-at, and href to the chosen variant
 *   3) toggles is-selected + aria-pressed on swatches
 */
(function () {
  if (window.__nfCardSwatchInit) return;
  window.__nfCardSwatchInit = true;

  function selectSwatch(swatch) {
    var card = swatch.closest('.nf-card');
    if (!card) return;

    // Image
    var img = card.querySelector('.nf-card__img');
    var newSrc = swatch.dataset.cardImage;
    var newSrcset = swatch.dataset.cardImageSrcset;
    if (img && newSrc) {
      img.src = newSrc;
      if (newSrcset) img.srcset = newSrcset; else img.removeAttribute('srcset');
    }

    // Price
    var price = card.querySelector('.nf-card__price');
    if (price && swatch.dataset.cardPrice) price.textContent = swatch.dataset.cardPrice;

    // Compare-at — add/remove inline
    var priceRow = card.querySelector('.nf-card__price-row');
    var compare = card.querySelector('.nf-card__compare');
    var newCompare = swatch.dataset.cardCompare;
    if (priceRow) {
      if (newCompare && newCompare.length > 0) {
        if (!compare) {
          compare = document.createElement('s');
          compare.className = 'nf-card__compare';
          priceRow.appendChild(compare);
        }
        compare.textContent = newCompare;
      } else if (compare) {
        compare.remove();
      }
    }

    // Card href — so subsequent click on the card goes to chosen variant
    var newHref = swatch.dataset.cardHref;
    if (newHref) card.setAttribute('href', newHref);

    // Inline ATC (opt-in contexts): re-point the button at the chosen variant
    var addBtn = card.querySelector('[data-card-add]');
    if (addBtn && swatch.dataset.variantId) addBtn.dataset.variantId = swatch.dataset.variantId;

    // Update selected state across siblings
    var swatchGroup = swatch.closest('[data-card-swatches]');
    if (swatchGroup) {
      swatchGroup.querySelectorAll('.nf-card__swatch').forEach(function (s) {
        s.classList.toggle('is-selected', s === swatch);
        s.setAttribute('aria-pressed', s === swatch ? 'true' : 'false');
      });
    }

    // Fire a custom event so other components (analytics, cart) can react
    card.dispatchEvent(new CustomEvent('nf-card:variant-switch', {
      bubbles: true,
      detail: {
        variantId: swatch.dataset.variantId,
        color: swatch.dataset.color,
        href: newHref,
      },
    }));
  }

  // Click anywhere — only act if target is a swatch
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.nf-card__swatch');
    if (!swatch) return;
    // Stop the parent <a> from navigating
    e.preventDefault();
    e.stopPropagation();
    selectSwatch(swatch);
  }, { capture: true });

  // Keyboard a11y — Enter or Space on a focused swatch
  document.addEventListener('keydown', function (e) {
    var swatch = e.target.closest && e.target.closest('.nf-card__swatch');
    if (!swatch) return;
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    e.preventDefault();
    e.stopPropagation();
    selectSwatch(swatch);
  });

  // Hover preview — show the variant image while hovering its swatch.
  // On mouseleave, revert to the SELECTED swatch's image (not the original)
  // so the preview never overrides a confirmed selection.
  function previewSwatch(swatch) {
    if (!swatch || !swatch.dataset.cardImage) return;
    var card = swatch.closest('.nf-card');
    var img = card && card.querySelector('.nf-card__img');
    if (!img) return;
    if (!img.dataset.committedSrc) img.dataset.committedSrc = img.src;
    img.src = swatch.dataset.cardImage;
    if (swatch.dataset.cardImageSrcset) img.srcset = swatch.dataset.cardImageSrcset;
  }
  function revertPreview(card) {
    var img = card && card.querySelector('.nf-card__img');
    if (!img) return;
    var selected = card.querySelector('.nf-card__swatch.is-selected');
    // Prefer the selected swatch's image; fall back to the committed source
    if (selected && selected.dataset.cardImage) {
      img.src = selected.dataset.cardImage;
      if (selected.dataset.cardImageSrcset) img.srcset = selected.dataset.cardImageSrcset;
    } else if (img.dataset.committedSrc) {
      img.src = img.dataset.committedSrc;
    }
  }
  // Use mouseover/mouseout (bubble) instead of mouseenter/leave so event
  // delegation works on a parent listener.
  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.nf-card__swatch');
    if (!swatch) return;
    previewSwatch(swatch);
  });
  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('.nf-card__swatch');
    if (!swatch) return;
    // Only revert if moving OUTSIDE the swatch group, not just between sibling swatches
    var toEl = e.relatedTarget;
    var swatchGroup = swatch.closest('[data-card-swatches]');
    if (toEl && swatchGroup && swatchGroup.contains(toEl)) return;
    var card = swatch.closest('.nf-card');
    revertPreview(card);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tech-specs-modal"] && !Shopify.designMode) return;
  try {
    class TechSpecsModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.closeBtn = this.querySelector('[data-close-modal]');

      this.closeBtn?.addEventListener('click', () => this.close());
      this.dialog?.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });
      /* 'close' fires for every close path (X, backdrop, native ESC) */
      this.dialog?.addEventListener('close', () => {
        if (window.NanoleafScrollLock) window.NanoleafScrollLock.unlock('tech-specs-modal');
      });
    }

    open() {
      this.dialog?.showModal();
      /* Shared lock (assets/nf-scroll-lock.js) — native <dialog> does not
         stop the page behind it from scrolling. */
      if (window.NanoleafScrollLock) window.NanoleafScrollLock.lock('tech-specs-modal');
    }

    close() {
      this.dialog?.close();
    }
  }

  if (!customElements.get('tech-specs-modal')) {
    customElements.define('tech-specs-modal', TechSpecsModal);
  }
  } catch(e) { console.error(e); }
})();

})();
